import React from 'react';
import { HStack } from '@chakra-ui/react';
import { Avatar, IconButton, Text } from '@melio/penny';

import { useRouter } from '@/hooks/router.hooks';
import { useIsMobile } from '@/hooks/useIsMobile';
export interface SubPageHeading {
  displayName: string;
  imageUrl?: string;
}

export const SettingsSubPageHeading = ({ displayName, imageUrl }: SubPageHeading) => {
  const isMobile = useIsMobile();
  const { goToSettings } = useRouter();

  return (
    <HStack gridGap={{ xs: 0, s: 4 }} alignItems={'center'} mb={{ xs: '24px', s: 10 }}>
      {isMobile && <IconButton icon="chevron-left" aria-label="Go back" variant="naked" onClick={goToSettings} />}
      <Avatar name={displayName} size="medium" src={imageUrl} />
      <Text textStyle="body2Semi">{displayName}</Text>
    </HStack>
  );
};

SettingsSubPageHeading.displayName = 'SettingsSubPageHeading';
